/**
 * DeliveryAudit
 * @author ftgibran
 */

export enum DeliveryAudit {
  APPROVED = 1,
  DISAPPROVED = 2,
  UNAUDITED = 3,
}
